<div style="position: relative">
  @if (getDisplayValue) {
    <kpi4me-select-element
      [formControlElement]="formControlElement"
      [disabled]="disabled"
      [data]="selectionData"
      [compareWith]="compareBy"
      (modelChange)="onSelectedRowChange($event)"
      (newElementClick)="onNew($event)"
      (changeElementClick)="onEdit($event)"
      (deleteElementClick)="delete($event)"
      [editEnabled]="editEnabled"
      [createNewEnabled]="showNew"
      [deleteEnabled]="showDelete"
      [singleStringArray]="singleStringArray"
      [newButtonLabel]="newButtonLabel"
    />
  } @else {
    <ng-template>
      Table Row Selection needs a get Display Value function as input.
    </ng-template>
  }


  @if (loading()) {
    <mat-progress-bar [mode]="'indeterminate'" style="position: absolute; width: 100%"/>
  }
</div>
